import CartRepository from '~repositories/CartRepository/CartRepository';
import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/CartService';
import CartSidebar from '~domain/entities/CartSidebar/CartSidebar';
import { IRemoveKitPayload } from '~api/KitsAPI/IKitsAPI';

export default class RemoveKitItemUseCase {
    private cartRepository: CartRepository;
    private cartSidebar: CartSidebar;
    private readonly body: IRemoveKitPayload;

    constructor(body: IRemoveKitPayload) {
        this.cartRepository = diContainer.get(serviceNames.cartRepository);
        this.cartSidebar = diContainer.get(serviceNames.cartSidebar);
        this.body = body;
    }

    public execute = async () => {
        try {
            this.cartSidebar.setLoading(true);

            await this.cartRepository.removeKitItem(this.body);
        } finally {
            this.cartSidebar.setLoading(false);
        }
    };
}
